import { Component, OnInit , Inject, Input } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';


import { ServicepoolService } from '../services/servicepool.service';


export interface DialogData {
	ParamsName : string[]; 
	typechoice: string[];
}


@Component({
  selector: 'app-recurrent',
  templateUrl: './recurrent.component.html',
  styleUrls: ['./recurrent.component.css']
})
export class RecurrentComponent implements OnInit {

  allInsurances = [] ;
  choosenParams = [] ;


  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 4 ;

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  saveBtnState = "done_all" ;

  eltsType = [] ;

  baseElement = "" ;

  choosedCategoryIndex : any ;
  currentCategGaranties : any ;
  currentInsuranceCategs : any ;
  activeChoice : any ;
  currentInsurance : any ;
  choosedInsuranceIndex : any ;
  canAdd = false ;



  constructor(public dialogRef: MatDialogRef<RecurrentComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog,  private configServer: ServicepoolService) {
    //this.allInsurances =  this.getAllPredefined() ;  
    //console.log(this.allInsurances) ;
  	this.getAllConfigs() ;  
  }



  ngOnInit(): void {}


  getAllConfigs(){

    this.configServer.getAllConfigsglobal("thiswii").then( (retourbi) => {
      var statutreq = retourbi.statutreq;
      if(statutreq==1){
        console.log("Done") ;
        this.allInsurances = retourbi.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;
  }


  getAllPredefined(){
  	return JSON.parse(sessionStorage.getItem('allinsurances')) ;
  }

  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: nomParam,
        typechoice: ["***"]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The Type COnfiguration is ::: ');
      this.eltsType[typeIndex] = result ;
    });
  }

	saveVehicParams(){
		var typologie = [] ;

    for (var i = 0; i< this.checkboxEditDeactivate.length; i++) {
      this.checkboxEditDeactivate[i] = true ;
    }
    var allParamsConfigs = [] ;
    for (var i = 0; i< this.checkStatus.length; i++) {
      if(this.checkStatus[i] == true){
        var choosedInsideParam = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[i].intitule;
        var paramRecurrentIntitule = choosedInsideParam+"("+this.allInsurances[this.choosedInsuranceIndex].intitule+")"+"("+this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].intitule+")" ;
        var paramRecurrent = choosedInsideParam+"|"+this.allInsurances[this.choosedInsuranceIndex].nomFrmt+"|"+this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].nomFrmt ;
        this.choosenParams.push({"nomFrmt": this.formatThisString(paramRecurrent), "intitule": paramRecurrentIntitule, "type":"recurrent"}) ;        
      }
    }

		var ret = JSON.stringify({"choosenParams": this.choosenParams, "typos": typologie }) ;
		console.log(ret) ;
		this.dialogRef.close(ret);
	}


  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+4*i]=true ;
  	}
  	else{
  	  	console.log("UNCHECKED "+event.target.value) ;
    	this.checkStatus[j+4*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }


  selectedOrCreateAssurance(event){
    this.activeChoice = 0 ;
    this.canAdd = true ;     
    this.currentInsurance = this.allInsurances[event.value] ;
    this.currentInsuranceCategs = this.allInsurances[event.value].categs ;
    this.choosedInsuranceIndex = event.value ;
  }



  configEnsForcateg(indexArg){

    this.choosedCategoryIndex = indexArg ;
    this.currentCategGaranties = this.currentInsuranceCategs[this.choosedCategoryIndex].garanties ;

  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.currentCategGaranties.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength)
  		if(!onChunkArray[chunkIndex]) {
  			onChunkArray[chunkIndex] = [] ;
  		}
  		onChunkArray[chunkIndex].push(item) ;
  		index++ ;
  		return onChunkArray ;
  	}, []) ;

  	for (var i = 0; i< this.currentCategGaranties.length; i++) {
  		this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;
  		this.eltsType.push([]) ;
  	}

      this.activeChoice = 1 ;
  }


  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


}
